/* eslint-disable max-len */
const initialState =
{
	toolAreaOpen                 : false,
	currentToolTab               : '', // chat, settings, users
	helpToolTab                  : 'help', // help, meeting
	pollingTab                   : 'single choice',
	unreadMessages               : 0,
	unreadFiles                  : 0,
	templateIsScreenShare        : true,
	templateIsWhiteboard         : true,
	templateIsChat               : true,
	templateIsAddCam             : true,
	templateIsFileShare          : true,
	templateIsCloudRecording     : false,
	templateHidePart             : false,
	templateNotificationSound    : true,
	templateNotification         : true,
	templateBreakOutRoom         : true,
	templateLockRoom             : true,
	templateChatMsgs             : true,
	templateSendFiles          	 : true,
	templateMicrophoneAccess     : true,
	templateVideoAccess          : true,
	templateExitUrl              : '',
	templateWaitingRoomUrlStatus : true,
	templateWaitingRoomUrl       : '',
	templateNoRecording        	 : true,
	brandingImageLogo            : '',
	openChatEmoji                : false,
	selectedChatEmoji            : '',
	selectedAnimeEmoji           : [],
	pollingsList                 : [],
	currentPollingData           : {},
	currentResultPollObj         : {},
	isPollOpen                   : false,
	peersPollSubmitObj           : {},
	currentModifyingPollObj      : {},
	hostControlSendChat          : false,
	hostControlPrivateChat    		 : false,
	hostControlSendFiles         : false,
	hostControlMicroPhone        : false,
	hostControlVideoControl      : false,
	hostControlCC                : false,
	hostControlCoHostTC          : false,
	hostControlEmojis            : true,
	hostControlScreenShare       : true,
	hostControlAnnotation        : true,
	hostRequestedPeerVideo       : false,
	hostRequestedPeerAudio       : false,
	usersTab                     : 'Participants',
	showParticipantActions     		: false,
	pollingActive                : false,
	participantsTab              : 'participants'
};

const toolarea = (state = initialState, action) =>
{
	switch (action.type)
	{
		case 'TOGGLE_TOOL_AREA':
		{
			const toolAreaOpen = !state.toolAreaOpen;
			const unreadMessages = toolAreaOpen && state.currentToolTab === 'chat' ? 0 : state.unreadMessages;
			const unreadFiles = toolAreaOpen && state.currentToolTab === 'chat' ? 0 : state.unreadFiles;

			return { ...state, toolAreaOpen, unreadMessages, unreadFiles, pollingTab: 'single choice' };
		}

		case 'OPEN_TOOL_AREA':
		{
			const toolAreaOpen = true;
			const unreadMessages = state.currentToolTab === 'chat' ? 0 : state.unreadMessages;
			const unreadFiles = state.currentToolTab === 'chat' ? 0 : state.unreadFiles;

			return { ...state, toolAreaOpen, unreadMessages, unreadFiles };
		}

		case 'CLOSE_TOOL_AREA':
		{
			const toolAreaOpen = false;

			return { ...state, toolAreaOpen };
		}

		case 'SET_HELP_TAB':
		{
			const { helpTab } = action.payload;

			return { ...state, helpToolTab: helpTab };
		}

		case 'SET_TOOL_TAB':
		{
			const { toolTab } = action.payload;

			const unreadMessages = toolTab === 'chat' ? 0 : state.unreadMessages;
			const unreadFiles = toolTab === 'chat' ? 0 : state.unreadFiles;

			return { ...state, currentToolTab: toolTab, unreadMessages, unreadFiles };
		}
		case 'SET_USERS_TAB':
		{

			const { usersTab } = action.payload;

			return { ...state, usersTab };
		}

		case 'ADD_MESSAGE':
		{
			if (state.toolAreaOpen && state.currentToolTab === 'chat')
			{
				return state;
			}

			return { ...state, unreadMessages: state.unreadMessages + 1 };
		}

		case 'ADD_FILE':
		{
			if (state.toolAreaOpen && state.currentToolTab === 'chat')
			{
				return state;
			}

			return { ...state, unreadFiles: state.unreadFiles + 1 };
		}

		case 'TEMPLATE_HIDE_SCREENSHARE':
		{
			const { templateIsScreenShare } = action.payload;

			return { ...state, templateIsScreenShare };
		}

		case 'TEMPLATE_HIDE_WHITEBOARD':
		{
			const { templateIsWhiteboard } = action.payload;

			return { ...state, templateIsWhiteboard };
		}

		case 'TEMPLATE_HIDE_CHAT':
		{
			const { templateIsChat } = action.payload;

			return { ...state, templateIsChat };
		}

		case 'TEMPLATE_HIDE_ADDIONAL_CAM':
		{
			const { templateIsAddCam } = action.payload;

			return { ...state, templateIsAddCam };
		}

		case 'TEMPLATE_HIDE_FILESHARE':
		{
			const { templateIsFileShare } = action.payload;

			return { ...state, templateIsFileShare };
		}
		case 'TEMPLATE_CLOUD_RECORDING':
		{
			const { templateIsCloudRecording } = action.payload;

			return { ...state, templateIsCloudRecording };
		}

		case 'TEMPLATE_HIDE_PARTICIPANTS_NV':
		{
			const { templateHidePart } = action.payload;

			return { ...state, templateHidePart };
		}

		case 'TEMPLATE_NOTIFICATIONS_SOUND':
		{
			const { templateNotificationSound } = action.payload;

			return { ...state, templateNotificationSound };
		}

		case 'TEMPLATE_NOTIFICATION_OFF':
		{
			const { templateNotification } = action.payload;

			return { ...state, templateNotification };
		}
		case 'BREAKOUT_ROOM_OFF':
		{
			const { templateBreakOutRoom } = action.payload;

			return { ...state, templateBreakOutRoom };
		}
		case 'LOCK_ROOM_OFF':
		{
			const { templateLockRoom } = action.payload;

			return { ...state, templateLockRoom };
		}
		case 'SEND_CHAT_MSGS':
		{
			const { templateChatMsgs } = action.payload;

			return { ...state, templateChatMsgs };
		}
		case 'SEND_FILES':
		{
			const { templateSendFiles } = action.payload;

			return { ...state, templateSendFiles };
		}
		case 'MICROPHONE_ACCESS':
		{
			const { templateMicrophoneAccess } = action.payload;

			return { ...state, templateMicrophoneAccess };
		}
		case 'VIDEO_ACCESS':
		{
			const { templateVideoAccess } = action.payload;

			return { ...state, templateVideoAccess };
		}
		case 'EXIT_URL':
		{
			const { templateExitUrl } = action.payload;

			return { ...state, templateExitUrl };

		}
		case 'WAITING_ROOM_URL_STATUS':
		{
			const { templateWaitingRoomUrlStatus } = action.payload;

			return { ...state, templateWaitingRoomUrlStatus };
		}
		case 'WAITING_ROOM_URL':
		{
			const { templateWaitingRoomUrl } = action.payload;

			return { ...state, templateWaitingRoomUrl };
		}
		case 'NO_RECORDING':
		{
			const { templateNoRecording } = action.payload;

			return { ...state, templateNoRecording };
		}
		case 'BRANDING_IMAGE':
		{
			const { brandingImageLogo } = action.payload;

			return { ...state, brandingImageLogo };
		}
		case 'SELECTED_TAB':
		{
			const { pollingTab } = action.payload;

			return { ...state, pollingTab };
		}
		case 'HANDLE_OPEN_CHAT_EMOJI':
		{
			const { openChatEmoji } = action.payload;

			return { ...state, openChatEmoji };
		}
		case 'SELECTED_CHAT_EMOJI':
		{
			const { selectedChatEmoji } = action.payload;

			return { ...state, selectedChatEmoji };
		}
		case 'SELECTED_ANIME_EMOJI':
		{
			const { emojiObj } = action.payload;

			const emojiArray = state.selectedAnimeEmoji;

			// eslint-disable-next-line max-len
			const filteredEmojiArray = emojiArray.filter((element) => element.emojiMeId !== emojiObj.emojiMeId);

			const time = new Date();

			time.setSeconds(time.getSeconds() + 5);
			emojiObj['timeOut'] = time.valueOf();
			filteredEmojiArray.push(emojiObj);

			return { ...state, selectedAnimeEmoji: filteredEmojiArray };
		}
		case 'REMOVE_ANIME_EMOJI':
		{

			const emojiArray = state.selectedAnimeEmoji;

			const time = new Date().valueOf();

			const filteredEmojiArray = emojiArray.filter((element) => element.timeOut > time);
			// function removeEmoji()
			// {
			// }

			// setInterval(removeEmoji, 1000);

			return { ...state, selectedAnimeEmoji: filteredEmojiArray };
		}

		case 'SET_POLLINGS_LIST':
		{

			const { pollingData } = action.payload;

			// eslint-disable-next-line max-len, newline-before-return
			return { ...state, currentPollingData: pollingData, pollingsList: [ ...state.pollingsList, pollingData ] };
		}
		case 'SET_POLL_DIALOGUE':
		{
			const { isPollOpen } = action.payload;

			return { ...state, isPollOpen };

		}

		case 'SET_PEER_OPEN_POLL_DIALOGUE':
		{
			const { poll } = action.payload;

			return { ...state, currentPollingData: poll };

		}

		// case 'SET_CURRENT_POLLING':
		// {

		// 	const { pollingData } = action.payload;

		// 	return { ...state, currentPollingData: pollingData };
		// }

		case 'SET_CURRENT_RESULT_POLL':
		{
			const { poll } = action.payload;

			return { ...state, currentResultPollObj: poll };
		}

		case 'SET_PEER_POLL_SUBMIT_LIST':
		{
			const { pollSubmitData } = action.payload;

			const peerSubmitObj = state.peersPollSubmitObj[pollSubmitData?.pollId];

			if (pollSubmitData?.alreadySubmit)
			{
				if (peerSubmitObj?.options && peerSubmitObj?.options?.length > 0 && pollSubmitData?.questionType === 'single')
				{
					peerSubmitObj.options[pollSubmitData?.alreadySubmitInd].votes = peerSubmitObj?.options[pollSubmitData?.alreadySubmitInd]?.votes - 1;
					peerSubmitObj.options[pollSubmitData?.index].votes = peerSubmitObj?.options[pollSubmitData?.index]?.votes + 1;
				}
				else if (peerSubmitObj?.options && peerSubmitObj?.options?.length > 0 && pollSubmitData?.questionType === 'multi')
				{
					for (const eachInd of pollSubmitData?.alreadySubmitInd)
					{
						// eslint-disable-next-line max-len
						peerSubmitObj.options[eachInd].votes = peerSubmitObj?.options[eachInd]?.votes - 1;
					}
					for (const eachInd of pollSubmitData?.index)
					{
						// eslint-disable-next-line max-len
						peerSubmitObj.options[eachInd].votes = peerSubmitObj?.options[eachInd]?.votes + 1;
					}
				}
			}
			else
			if (peerSubmitObj?.options && peerSubmitObj?.options?.length > 0 && pollSubmitData?.questionType === 'single')
			{
				// eslint-disable-next-line max-len
				peerSubmitObj.options[pollSubmitData?.index].votes = peerSubmitObj?.options[pollSubmitData?.index]?.votes + 1;
				peerSubmitObj.submittedUsers.push(pollSubmitData?.userId);
			}
			else if (peerSubmitObj?.options && peerSubmitObj?.options?.length > 0 && pollSubmitData?.questionType === 'multi')
			{
				for (const eachInd of pollSubmitData?.index)
				{
					// eslint-disable-next-line max-len
					peerSubmitObj.options[eachInd].votes = peerSubmitObj?.options[eachInd]?.votes + 1;
				}
				peerSubmitObj.submittedUsers.push(pollSubmitData?.userId);
			}

			const newObj = {};

			newObj[pollSubmitData.pollId] = peerSubmitObj;

			return { ...state, peersPollSubmitObj: { ...state.peersPollSubmitObj, ...newObj } };
		}

		case 'UPDATE_POLL_SUBMIT_LIST':
		{
			const { pollId, pollSubmitData } = action.payload;

			const obj = { ...state.peersPollSubmitObj };

			obj[pollId] = pollSubmitData;

			return { ...state, peersPollSubmitObj: obj };
		}

		case 'SET_RESULT_OBJ':
		{
			const { poll } = action.payload;

			const optionsObj = [];

			poll.options.forEach((val) =>
			{
				optionsObj.push({ option: val, votes: 0 });
			});

			// eslint-disable-next-line max-len
			const finaltObj = Object.assign({}, poll, { options: optionsObj, submittedUsers: [] });
			const obj = { ...state.peersPollSubmitObj };

			obj[poll._id] = finaltObj;

			return { ...state, peersPollSubmitObj: obj };
		}

		case 'SET_MODIFY_POLL':
		{
			const { poll } = action.payload;

			let pollObj = {};

			if (poll?.isActive === false)
			{
				pollObj = poll;
			}

			return { ...state, currentModifyingPollObj: pollObj };
		}

		case 'HANDLE_HOST_CONTROLS':
		{
			const { hostControlsObj } = action.payload;
			const finalObj = {
				hostControlSendChat     : state.hostControlSendChat,
				hostControlPrivateChat  : state.hostControlPrivateChat,
				hostControlSendFiles    : state.hostControlSendFiles,
				hostControlMicroPhone   : state.hostControlMicroPhone,
				hostControlVideoControl : state.hostControlVideoControl,
				hostControlScreenShare  : state.hostControlScreenShare,
				hostControlEmojis       : state.hostControlEmojis,
				hostControlAnnotation   : state.hostControlAnnotation
			};

			if (Object.keys(hostControlsObj).length > 0)
			{
				for (const each of Object.keys(hostControlsObj))
				{
					finalObj[each] = hostControlsObj[each];
				}
			}

			return { ...state, ...finalObj };
		}

		case 'SET_HOST_CONTROLS':
		{
			const { hostControlsObj } = action.payload;

			console.log('hostControlsObj===', hostControlsObj);
			const finalObj = {
				hostControlSendChat     : state.hostControlSendChat,
				hostControlPrivateChat  : state.hostControlPrivateChat,
				hostControlSendFiles    : state.hostControlSendFiles,
				hostControlMicroPhone   : state.hostControlMicroPhone,
				hostControlVideoControl : state.hostControlVideoControl,
				hostControlScreenShare  : state.hostControlScreenShare,
				hostControlEmojis       : state.hostControlEmojis,
				hostControlAnnotation   : state.hostControlAnnotation,
				hostControlCC           : state.hostControlCC,
				hostControlCoHostTC     : state.hostControlCoHostTC
			};

			if (Object.keys(hostControlsObj).length > 0)
			{
				for (const each of Object.keys(hostControlsObj))
				{
					finalObj[each] = hostControlsObj[each];
				}
			}

			return { ...state, ...finalObj };
		}

		case 'SET_HOST_REQUEST_PEER_VIDEO_OR_AUDIO':
		{
			const { requestObj } = action.payload;

			let hostRequestedVideo = false;

			let hostRequestedAudio = false;

			if (requestObj.type === 'video' && requestObj.value === true)
			{
				hostRequestedVideo = true;
			}

			if (requestObj.type === 'audio' && requestObj.value === true)
			{
				hostRequestedAudio = true;
			}

			return { ...state, hostRequestedPeerVideo: hostRequestedVideo, hostRequestedPeerAudio: hostRequestedAudio };
		}

		case 'SHOW_PARTICIPANT_ACTIONS':
		{
			const { showParticipantActions } = action.payload;

			return { ...state, showParticipantActions };

		}
		case 'SET_POLLING_ACTIVE':
		{
			const { pollingActive } = action.payload;

			return { ...state, pollingActive };

		}
		case 'SET_PARTICIPANTS_TAB':
		{
			const { participantsTab } = action.payload;

			return { ...state, participantsTab };

		}

		default:
			return state;
	}
};

export default toolarea;
